import { Link } from 'react-router-dom';
import { type Article } from '@/mocks/articles';

export default function ArticleCard({ article, variant = 'default' }: { article: Article; variant?: 'default' | 'horizontal' | 'compact' }) {
  if (variant === 'horizontal') {
    return (
      <article className="flex flex-col sm:flex-row gap-4 p-4 md:p-5 bg-background-50 border border-background-200/60 rounded-lg hover:border-primary-200 transition-colors group">
        <Link to={`/article/${article.slug}`} className="block w-full sm:w-48 flex-shrink-0 overflow-hidden rounded-lg">
          <img
            src={article.imageUrl}
            alt={article.title}
            className="w-full h-32 sm:h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
          />
        </Link>
        <div className="flex flex-col justify-between flex-1 min-w-0">
          <div>
            <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
              <Link to={`/category/${article.categorySlug}`} className="text-primary-500 font-medium hover:text-primary-600 whitespace-nowrap">
                {article.category}
              </Link>
              <span>{article.publishedAt}</span>
              <span>{article.readTime} 分钟</span>
            </div>
            <Link to={`/article/${article.slug}`} className="block">
              <h3 className="text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                {article.title}
              </h3>
            </Link>
            <p className="text-sm text-foreground-600 line-clamp-2">{article.excerpt}</p>
          </div>
        </div>
      </article>
    );
  }

  if (variant === 'compact') {
    return (
      <article className="flex gap-3 p-3 bg-background-50 border border-background-200/60 rounded-lg hover:border-primary-200 transition-colors group">
        <Link to={`/article/${article.slug}`} className="block w-20 h-20 flex-shrink-0 overflow-hidden rounded-lg">
          <img
            src={article.imageUrl}
            alt={article.title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
          />
        </Link>
        <div className="flex flex-col justify-between min-w-0 flex-1">
          <Link to={`/article/${article.slug}`} className="block">
            <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
              {article.title}
            </h3>
          </Link>
          <span className="text-xs text-foreground-500">{article.publishedAt}</span>
        </div>
      </article>
    );
  }

  return (
    <article className="flex flex-col bg-background-50 border border-background-200/60 rounded-lg overflow-hidden hover:border-primary-200 transition-colors group h-full">
      <Link to={`/article/${article.slug}`} className="block overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
      </Link>
      <div className="flex flex-col flex-1 p-4 md:p-5">
        <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3 flex-wrap">
          <Link to={`/category/${article.categorySlug}`} className="text-primary-500 font-medium hover:text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">
            {article.category}
          </Link>
          <span>{article.publishedAt}</span>
          <span>{article.readTime} 分钟</span>
        </div>
        <Link to={`/article/${article.slug}`} className="block flex-1">
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-3">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 line-clamp-3 mb-4">{article.excerpt}</p>
        <div className="flex items-center gap-2 mt-auto pt-3 border-t border-background-200/60">
          <img
            src={article.authorAvatar}
            alt={article.author}
            className="w-6 h-6 rounded-full object-cover"
          />
          <span className="text-xs text-foreground-600">{article.author}</span>
        </div>
      </div>
    </article>
  );
}